import e from 'classnames';
import t, {
  useState as n,
  useRef as a,
  useEffect as l,
  createContext as c,
  Children as r,
  useContext as i,
} from 'react';
import { createDebounceFn as s } from '@retailtune/utils';
const o = ({ title: a, children: l }) => {
    const [c, r] = n(!1);
    return t.createElement(
      'div',
      { className: 'accordion-item' },
      t.createElement(
        'div',
        { className: 'accordion-bar', onClick: () => r(!c) },
        t.createElement('span', { className: 'accordion-title' }, a),
        t.createElement('span', { className: 'accordion-action' }, c ? '-' : '+'),
      ),
      t.createElement('div', { className: e('accordion-content', { 'accordion-opened': c }) }, l),
    );
  },
  m = s()(400);
function d({
  value: c,
  setValue: r,
  searchHandler: i,
  predictionClickHandler: s,
  placeholder: o,
  clearIcon: d,
  searchIcon: u,
  zeroResultsMessage: p,
}) {
  const [v, E] = n(c),
    [f, h] = n([]),
    [g, N] = n(!1),
    [k, b] = n(null),
    [C, w] = n(null),
    y = a(null);
  l(() => {
    function e(e) {
      e.target !== y.current && N(!1);
    }
    return document.addEventListener('click', e), () => document.removeEventListener('click', e);
  }, []),
    l(() => {
      '' === c.trim() ? x() : E(c);
    }, [c]);
  const x = () => {
      r(''), E(''), N(!1), h([]), w(null);
    },
    L = (e) => {
      const t = e.target.value.trim();
      return t
        ? t.length < 3
          ? void 0
          : (async (e) => {
              const t = (await i(e)).slice(0, 5);
              h(t), N(!0), b(t.length > 0 ? 0 : null), w(t.length > 0 ? null : p);
            })(t)
        : x();
    },
    _ = (e) => {
      E(e.description), r(e.description), N(!1), h([]), w(null), s(e);
    };
  return t.createElement(
    'div',
    { className: 'rt-autocomplete-wrapper' },
    t.createElement(
      'div',
      {
        className: e('rt-autocomplete', { 'rt-autocomplete--open': g }),
        onKeyDown: function (e) {
          if (0 === f.length) return;
          if (null === k) return;
          let t = k;
          if ('Enter' === e.key) {
            const e = t ? f[t] : f[0];
            return _(e);
          }
          return 'ArrowUp' === e.key
            ? (void 0 === t || 0 === t ? (t = f.length - 1) : (t -= 1), b(t))
            : 'ArrowDown' === e.key
            ? (void 0 === t || t === f.length - 1 ? (t = 0) : (t += 1), b(t))
            : void 0;
        },
      },
      t.createElement(
        'div',
        { className: 'input-container' },
        t.createElement('input', {
          ref: y,
          className: 'user-input',
          value: v,
          onChange: (e) => {
            E(e.target.value), m(L, e);
          },
          onClick: () => {
            (f.length > 0 || C) && N(!0);
          },
          placeholder: o ?? '',
        }),
        d &&
          t.createElement(
            'button',
            {
              className: e('icon clear-icon', {
                'icon--left': 'left' === d.position,
                'icon--right': 'right' === d.position,
                'icon--visible': v.length > 0,
              }),
              onClick: x,
            },
            t.createElement('img', { src: d.path, alt: 'X' }),
          ),
        u &&
          t.createElement(
            'button',
            {
              className: e('icon search-icon', {
                'icon--left': 'left' === u.position,
                'icon--right': 'right' === u.position,
              }),
              disabled: 0 === v.length || 0 === f.length,
              onClick: () => {
                null !== k && _(f[k]);
              },
            },
            t.createElement('img', { src: u.path, alt: '' }),
          ),
      ),
      t.createElement(
        'ul',
        { className: 'predictions' },
        0 === f.length && C
          ? t.createElement('li', { key: '__zero_results_msg', className: 'prediction prediction--zero-results' }, p)
          : f.map((n, a) =>
              t.createElement(
                'li',
                {
                  key: a,
                  className: e('prediction', { 'prediction--active': a === k }),
                  onClick: () => _(n),
                  onMouseOver: () => b(a),
                },
                n.description,
              ),
            ),
      ),
    ),
  );
}
function u({ label: a, fileUrl: c, setFileUrl: r, maxSize: i, allowedExtensions: s }) {
  const [o, m] = n(c),
    [d, u] = n(c.split('/').pop()),
    [p, v] = n(''),
    [E, f] = n(!1);
  return (
    l(() => {
      '' !== o && r(o);
    }, [o]),
    t.createElement(
      'div',
      { className: 'file-picker' },
      t.createElement(
        'div',
        { className: 'flex-container' },
        t.createElement(
          'label',
          { className: 'upload-label btn btn-primary' },
          t.createElement('input', {
            type: 'file',
            onChange: (e) => {
              let t = !1;
              v('');
              const n = e.target.files[0];
              if (i) {
                n.size > i && ((t = !0), v(`Max allowed size is: ${i} bytes`), f(!0));
              }
              if (!t && s) {
                const e = n.name.split('.').pop();
                s.includes(e) || ((t = !0), v(`Only allowed extensions are: ${s.join(', ')}`), f(!0));
              }
              if (!t) {
                const e = URL.createObjectURL(n);
                m(e), u(n.name);
              }
            },
          }),
          a,
        ),
        t.createElement('p', { className: 'loaded-file' }, d || 'No file chosen'),
      ),
      t.createElement(
        'p',
        {
          className: e('rt-msg rt-msg--error', { 'rt-msg--visible': '' !== p, 'rt-msg--animated': E }),
          onAnimationEnd: () => f(!1),
        },
        p,
      ),
    )
  );
}
function p({ isOpen: n, setOpen: a, children: l, title: c, type: r }) {
  return t.createElement(
    'div',
    { className: e('rt-modalOverlay', { 'rt-hidden': !n }) },
    t.createElement(
      'div',
      { className: 'rt-modalContent' },
      t.createElement(
        'div',
        { className: `rt-headerDialog rt-${r}` },
        t.createElement('div', { className: 'rt-icon' }, t.createElement('i', { className: v(r) })),
        t.createElement('div', { className: 'rt-title' }, c),
        t.createElement(
          'div',
          { className: 'rt-close' },
          t.createElement('i', { onClick: () => a(!1), className: 'fa fa-times' }),
        ),
      ),
      t.createElement('div', { className: 'rt-contentDialog' }, t.createElement('div', { className: 'text' }, l)),
    ),
  );
}
const v = (e) => {
    switch (e) {
      case 'success':
        return 'fa fa-check';
      case 'error':
        return 'fa fa-exclamation-circle';
      case 'warning':
        return 'fa fa-exclamation-triangle';
      case 'info':
        return 'fa fa-info-circle';
      default:
        return '';
    }
  },
  E = s()(200);
function f({ userData: c, setUserData: r, column: i, placeHolder: s, encodeFn: o, decodeFn: m }) {
  const [d, u] = n([]),
    [p, v] = n(!1),
    [f, h] = n(!1),
    g = a(null),
    N = a(null),
    k = a(null);
  l(() => {
    const e = c.map(o);
    u(e.sort((e, t) => e.value.localeCompare(t.value)).map((e) => ({ ...e, filtered: !f || e.filtered })));
  }, [c]),
    l(() => {
      p && k.current?.focus();
    }, [p]);
  const b = (e) => {
      const t = d.map((t) => (t.id === e ? { ...t, selected: !t.selected } : t)).map(m);
      r(t);
    },
    C = (e) => {
      h(!0), u((t) => t.map((t) => ({ ...t, filtered: t.value.toLowerCase().includes(e.toLowerCase()) })));
    };
  return (
    l(() => {
      const e = (e) => {
        g.current?.contains(e.target) || N.current?.contains(e.target) || k.current?.contains(e.target) || v(!1);
      };
      return document.addEventListener('mousedown', e), () => document.removeEventListener('mousedown', e);
    }),
    t.createElement(
      'div',
      { className: 'rt-multiselect' },
      t.createElement(
        'div',
        { ref: g, className: 'rt-text' },
        t.createElement(
          'div',
          { className: 'rt-text-container' },
          d.map(
            (e) =>
              e.selected &&
              t.createElement(
                'div',
                { key: e.id, className: 'rt-text-sel-item' },
                t.createElement('span', { className: 'rt-value-selected' }, e.value),
                t.createElement(
                  'div',
                  { className: 'rt-delete-wrapper' },
                  t.createElement(
                    'a',
                    { className: 'rt-value-restore', onClick: () => b(e.id) },
                    t.createElement('i', { 'data-val': 'remove', className: 'fa fa-times' }),
                  ),
                ),
              ),
          ),
          t.createElement(
            'div',
            { className: 'rt-text-placeholder', onClick: () => v(!0) },
            0 == d.filter(({ selected: e }) => e).length ? s : '',
          ),
        ),
        t.createElement(
          'div',
          {
            onClick: () => {
              v(!p);
            },
            className: 'rt-open-multiselect',
          },
          t.createElement('i', { className: 'fa fa-chevron-down' }),
        ),
      ),
      t.createElement(
        'div',
        { ref: N, className: e('rt-option', { 'rt-opened': p }) },
        t.createElement(
          'div',
          { className: 'rt-search-container' },
          t.createElement('i', { className: 'fa fa-search' }),
          t.createElement('input', {
            ref: k,
            type: 'text',
            onChange: (e) => {
              return (t = e.currentTarget.value), void E(C, t);
              var t;
            },
            autoFocus: !0,
          }),
          '' != k.current?.value &&
            t.createElement('i', {
              className: 'fa fa-times',
              onClick: () => {
                (k.current.value = ''), C('');
              },
            }),
        ),
        t.createElement(
          'ul',
          null,
          d
            .filter((e) => e.filtered)
            .map((n) =>
              t.createElement(
                'li',
                {
                  key: n.id,
                  className: e('rt-value', { 'rt-option-selected': n.selected }),
                  onClick: () => !n.selected && b(n.id),
                  style: { flexBasis: 100 / (i < d.length ? i : d.length) + '%' },
                },
                n.value,
              ),
            ),
        ),
      ),
    )
  );
}
const h = c({ selectedOption: '' });
function g({
  placeholder: c,
  value: i,
  onChange: s,
  direction: o,
  type: m,
  opened: d = !1,
  className: u,
  disabled: p = !1,
  children: v,
}) {
  const [E, f] = n(d),
    [g, N] = n(i),
    [k, b] = n(),
    C = a(null);
  l(() => {
    f(d);
  }, [d]),
    l(() => {
      const e = new Map();
      r.forEach(v, (t) => {
        e.set(t.props.value, t.props.children);
      }),
        b(e);
    }, [E, v]),
    l(() => {
      function e(e) {
        C.current.contains(e.target) || f(!1);
      }
      return document.addEventListener('click', e), () => document.removeEventListener('click', e);
    }, []),
    l(() => {
      function e(e) {
        const t = e.detail;
        (C.current.value = t), N(t);
        const n = new Event('change');
        C.current?.dispatchEvent(n);
      }
      return (
        C.current?.addEventListener('option-click', e),
        C.current?.addEventListener('change', s),
        () => {
          C.current?.removeEventListener('option-click', e), C.current?.removeEventListener('change', s);
        }
      );
    }, []);
  const w = {
    'select--opened': E,
    'select--disabled': p,
    'select--mini': 'mini' === m,
    'select--up': 'up' === o,
    'select--down': !o || 'down' === o,
    'select--left': 'mini' === m && 'left' === o,
    'select--right': 'mini' === m && (!o || 'right' === o),
  };
  return (
    u && (w[u] = !0),
    t.createElement(
      'div',
      {
        className: e('select', w),
        onClick: () => {
          f((e) => !e);
        },
        ref: C,
      },
      t.createElement('div', { className: 'select__selected-text' }, k && '' !== g && k.has(g) ? k.get(g) : c),
      t.createElement(
        h.Provider,
        { value: { selectedOption: g } },
        t.createElement('ul', { className: 'select__option-list' }, v),
      ),
    )
  );
}
function N({ value: n, children: l }) {
  const c = a(null),
    r = i(h);
  return t.createElement(
    'li',
    {
      className: e('select__option-list__option', { 'select__option-list__option--selected': r.selectedOption === n }),
      ref: c,
      onClick: () => {
        const e = new CustomEvent('option-click', { bubbles: !0, detail: n });
        c.current.dispatchEvent(e);
      },
    },
    l,
  );
}
function k({ sidebarVisible: n, setSidebarVisible: c, triggerElementRef: r, position: i, children: s }) {
  const o = a(null);
  return (
    l(() => {
      function e(e) {
        o.current.contains(e.target) || r.current.contains(e.target) || c(!1);
      }
      return document.addEventListener('click', e), () => document.removeEventListener('click', e);
    }, []),
    t.createElement(
      'div',
      { className: e('overlay-sidebar', { 'overlay-sidebar--visible': n }) },
      t.createElement(
        'div',
        {
          className: e('sidebar', {
            'sidebar--visible': n,
            'sidebar--left': 'left' === i,
            'sidebar--right': 'right' === i,
          }),
          ref: o,
        },
        s,
      ),
    )
  );
}
export {
  o as Accordion,
  d as Autocomplete,
  u as FilePicker,
  p as Modal,
  f as MultiSelect,
  g as Select,
  N as SelectOption,
  k as Sidebar,
};
//# sourceMappingURL=index.es.js.map
